import { Link } from "react-router-dom";
import "./Footer.css";
import {
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import axios from "axios";

const defaultFooter = {
  description:
    "Akash Infra is committed to providing exceptional real estate services, transparency, and long-term value to our investors.",
  locations: {
    office1: "Office – Akash Infra,\nNear Bollywood Gali,\nPatiala-Chandigarh highway, Zirakpur",
    office2: "Property Bazaar – DSS-120,\nGround Floor\nOffice – Mohali City Centre, Aerocity, Mohali",
  },
  contact: {
    email: "dholera@akashinfra.in",
    phone: "+91-9915483066, +91-9010040001",
  },
  social: {
    instagram: "https://www.instagram.com/akash.infra/",
    facebook: "https://www.facebook.com/Akash.Infraa/",  
    whatsapp: "https://wa.me/919915483066",
  },
  copyright: "© 2025 Akash Infra. Developed by Social Simba",
};

const Footer = () => {
  const [footerData, setFooterData] = useState(defaultFooter);

  const API = process.env.REACT_APP_APIURL;

  useEffect(() => {
    axios
      .get(`${API}/api/footer`)
      .then((res) => {
        if (res.data) setFooterData(res.data);
      })
      .catch((err) => console.error("Footer fetch error:", err));
  }, [API]);

  const { description, locations, contact, social, copyright } = footerData;

  return (
    <footer className="footer">
      <div
        className="footer-bg"
        style={{ backgroundImage: "url('/images/bg-image.png')" }}
      >
        <div className="footer-overlay">
          <div className="footer-container">
            {/* COLUMN 1 — LOGO */}
            <div className="footer-col footer-left">
              <img
                src="/images/footer.png"
                alt="Akash Infra Logo"
                className="footer-logo"
              />

              <p className="footer-desc">{description}</p>

              <Link to="/about-us" className="footer-about-btn">
                About Us
              </Link>
            </div>

            {/* COLUMN 2 — QUICK LINKS */}
            <div className="footer-col footer-links">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About</Link></li>
                <li><Link to="/dholera-SIR">Dholera SIR</Link></li>
                <li><Link to="/dholera-smart-infrastructure">Infrastructure</Link></li>
                <li><Link to="/planning">Planning</Link></li>
                <li><Link to="/investment-opportunities">Investments</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/contact-us">Contact</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                <li><Link to="/disclaimer">Disclaimer</Link></li>
              </ul>
            </div>

            {/* COLUMN 3 — LOCATIONS */}
            <div className="footer-col footer-location-col">
              <h3>Locations</h3>

              {locations?.office1 && (
                <div className="footer-location">
                  <FaMapMarkerAlt className="footer-icon" />
                  <p>
                    {locations.office1.split("\n").map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </p>
                </div>
              )}

              {locations?.office2 && (
                <div className="footer-location">
                  <FaMapMarkerAlt className="footer-icon" />
                  <p>
                    {locations.office2.split("\n").map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </p>
                </div>
              )}
            </div>

            {/* COLUMN 4 — CONTACT */}
            <div className="footer-col footer-contact">
              <h3>Contact</h3>

              <div className="footer-line">
                <FaEnvelope className="footer-icon" />
                <a href={`mailto:${contact?.email}`} className="footer-email-link">
                  {contact?.email}
                </a>
              </div>

              <div className="footer-line">
                <FaPhoneAlt className="footer-icon" />
                <p>{contact?.phone}</p>
              </div>

              <div className="footer-socials">
                {social?.instagram && (
                  <a href={social.instagram} target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                )}
                {social?.facebook && (
                  <a href={social.facebook} target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                )}
                {social?.whatsapp && (
                  <a href={social.whatsapp} target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <p>{copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;
